import './home.css';
import NavBar from "../../components/navbar/navbar.jsx";
import Footer from "../../components/footer/footer.jsx";
import HomeGallery from "../../components/home-gallery/home-gallery.jsx";
import Testimonial from "../../components/testimonial/testimonial.jsx";
import ServiceCards from '../../components/service-cards/services-cards.jsx';
import Form from '../../components/form/form.jsx';

const LandingPage = () => {
    return (
        <div className="single-page">

            {/* HERO SECTION */}
            <section id="hero" className="hero">
                <div className="gradient">
                    <div>
                        <h1 className="gradient-h1">
                            Refine Your Space.<br/>Enhance Your Place.
                        </h1>
                        <p className="gradient-p">
                            Premium Craftsmanship. Locally Trusted.
                        </p>
                        <button className="gradient-button"><a className="gradient-a" href="/contact-us">Get Your Free Quote</a></button>
                    </div>    
                </div>    
            </section>

            <NavBar />

            <div className='home-inner'>
                <section id="services">
                    <h2 className="home-h2">What We Do</h2>
                    <ServiceCards />
                </section>

                <section id="about" className="section-padding">
                    <h2 className="home-h2">Why Choose Interior 4U</h2>
                    <div className='general-grid'>
                        <div>
                            <h3>Your local Melbourne renovation partner — one beautiful space at a time.</h3>
                            <p>
                                At Interior 4U, we believe no project is too small. From full-scale renovations to minor repairs, 
                                our team delivers exceptional craftsmanship and personalised solutions tailored to your needs.
                            </p>
                        </div>
                        <div className="img-wrapper">
                            <img className="img-wrapper-img" src='/static/images/fencing-installation-clayton.webp' alt='' />
                        </div>
                    </div> 
                </section>

                <section id="vision" className="section-padding">
                    <h2 className="home-h2">Our Vision</h2>
                    <div className='general-grid'>
                        <div className="img-wrapper">
                            <img className="img-wrapper-img" src='/static/images/our-vision-img.webp' alt='' />
                        </div>
                        <div>
                            <h3>“We aim to redefine home renovations by creating stylish, functional spaces that enhance your daily living experience.”</h3>
                            <p>Every project we undertake reflects our commitment to excellence and our passion for transforming spaces.</p>
                        </div>    
                    </div>
                </section>

                <section className="section-padding">
                    <h2 className="home-h2">Our Work & Reviews</h2>
                    <HomeGallery />
                    <div style={{marginTop: "60px"}}>
                        <Testimonial />
                    </div>
                </section>

                <section id="contact" className="section-padding contact">
                    <h2 className="home-h2">Let's Build Something Beautiful</h2>
                    <div className="intro-text">
                    <p className="lead-text">
                        Ready to kick off your renovation project? Or just have a few questions before getting started? 
                        <strong> We'd love to hear from you!</strong>
                    </p>

                    <div className="contact-grid">
                        <div className="detail-item">
                            <h3>Call Us</h3>
                            <a href="tel:0412279273" className="phone-link">0412 279 273</a>
                            <p className="sub-text">9 AM - 5 PM, Monday to Friday</p>
                        </div>

                        <div className="detail-item">
                            <h3>Prefer Writing?</h3>
                            <a href="mailto:info.interior4u@gmail.com" className="phone-link">info.interior4u@gmail.com</a>
                            <p className="sub-text">Or, fill out the form below for a free project quote.</p>
                        </div>
                    </div>
                </div>
                    <Form />
                </section>
            </div>
            <Footer />
        </div>
    );
};

export default LandingPage;